import InfoBlock from "./UI/InfoBlock";

export default InfoBlock